// Implement more logic here

import React from "react";
import { array, object } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { DfpComponent } from "../../ads/dfp-component";
import { StoryGrid } from "../../story-grid";

import "./four-col-grid.m.css";

export function FourColGrid({ collection, stories, customSectionTemplate = false }) {
  const footerAd = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "footer_1"], {}));

  return (
    <div styleName={customSectionTemplate ? "four-col-grid-container" : "row-component"}>
      {!customSectionTemplate && <h2 styleName="heading">{collection?.name}</h2>}
      <StoryGrid stories={stories} customSectionTemplate={customSectionTemplate} styleName="four-col-story-grid" />
      <div styleName="bottom-ad-container">
        <DfpComponent adStyleName="ad-slot-size-970x250" id={footerAd?.id} />
      </div>
    </div>
  );
}

FourColGrid.propTypes = {
  collection: object,
  stories: array,
};

FourColGrid.storyLimit = 8;
FourColGrid.nestedCollectionLimit = [1, 2, 3];
